export default __webpack_public_path__ + "static/Westpac-e82627c819f75f116b03480640f061d0.png";